import './currency-7be6806c.js';
import { s as store, a as pesRouterNavigationType } from './pes-router-store-0c1092be.js';

class PesRoute {
  constructor({ page, pageId, tabId, searchParams, }) {
    this.page = page;
    this.pageId = pageId;
    this.tabId = tabId;
    this.searchParams = searchParams;
  }
  buildAppPath() {
    const path = [
      store.get('base_dir'),
      store.get('country'),
      store.get('language'),
    ];
    if (this.page) {
      path.push(this.page);
    }
    if (this.pageId) {
      path.push(this.pageId);
    }
    return path.join('/');
  }
  get url() {
    if (store.get('navigation') === pesRouterNavigationType.EVENT) {
      return '#';
    }
    if (store.get('navigation') === pesRouterNavigationType.HASH) {
      return `${window.location.origin}${window.location.pathname}#/${this.buildAppPath()}/${this.tabId ? `${this.tabId}/` : ''}`;
    }
    return `${window.location.origin}/${this.buildAppPath()}/${this.tabId ? `#/${this.tabId}/` : ''}`;
  }
}

export { PesRoute as P };
